import { DateFormatter } from '@/support/DateFormatter';
import { Component, Prop, Vue } from 'vue-property-decorator';
import OverwriteDateDialog from '@/components/OverwriteDateDialog/OverwriteDateDialog.vue';
import DatePlanningInput from '@/components/DatePlanningInput/DatePlanningInput.vue';
import { OverwriteDateEvent } from '../OverwriteDateDialog/OverwriteDateDialog';

@Component<PreparationPlanningBlock>({
  components: {
    OverwriteDateDialog,
    DatePlanningInput,
  },
})
export default class PreparationPlanningBlock extends Vue {
  // #region @Props

  @Prop({ default: true })
  protected canEdit!: boolean;

  @Prop({ default: null })
  protected firstContact!: string | null;

  @Prop({ default: null })
  protected assessmentConversation!: string | null;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Class properties

  protected isEditingDate = false;

  protected date: DateFormatter = new DateFormatter();

  // #endregion

  // #region Lifecycle Hooks / Init

  // #endregion

  // #region Class methods

  protected onUpdateDate(field: string, date: string): void {
    this.$emit('updateDate', { field, date });
  }

  protected onOverwriteDate(field: string, event: OverwriteDateEvent): void {
    this.$emit('overwriteDate', { field, event });
  }

  // #endregion

  // #region Async methods

  // #endregion

  // #region Getters & Setters

  protected get firstContactIsScheduled(): boolean {
    return !! this.firstContact;
  }

  protected get assessmentConversationIsScheduled(): boolean {
    return !! this.assessmentConversation;
  }

  // #endregion

  // #region @Watchers

  // #endregion
}
